import trImage from '../assest/home/ourservic/15b351027783acfaa13afc24456f9f2a7c75f24a.png'
import Insurance from '../assest/home/ourservic/565425479bac7412bb2106cf77f9c0abcee65840.png'
import SaberSservice from '../assest/home/ourservic/98710b63cdb301bcce4d8538574a6ffb40c4da50.png'
import NajizService from '../assest//home//ourservic/d3345d10dc7b6c3be1efd0b1c6529b8c18efb915\ \(3\).png';
import MadadService from '../assest/home/ourservic/7da7d71abb595e841a65e9d9288a422f34cd3642.png';
import EngConsultation from '../assest/home/ourservic/87bd101704703daa31e50fa2cf3eae839a4a0edb.png'
import ComCr1 from '../assest/home/companyCreated/577091df763147abf57e5d76771bf6b19e65e8f4.png'
import ComCr2 from '../assest/home/companyCreated/3fd640ef5c44cdf1fa4e9ccb6cd516bad06b4199.png'
import ComCr3 from '../assest/home/companyCreated/c93453468705389def7c163c5e546cf3a739b10e.png'
import ComCr4 from '../assest/home/companyCreated/1798ba2b1e7667e5f57db6e281d493ed21cea763.png'
import ComCr5 from '../assest/home/companyCreated/dbc00943879e1a2d23f5c13aa0c5e53427f6c20c.png'
import ComCr6 from '../assest/home/companyCreated/91c28ccca00d34325c31460bf211b18a5d8b2089.png'
import ComCr7 from '../assest/home/companyCreated/3ca22f924472c05c96ce3cd5dbb6cdae1e7c38c5.png'
import ComCr8 from '../assest/home/companyCreated/d6a1e782633884078d48b9c954a43c6a1d15e8cc.png'
import Prim1 from '../assest/home/primResidency/43ffacdc6879d83e872e78df935d28016bac6d7c.png'
import Prim2 from '../assest/home/primResidency/4f1da8c4b53b9c099c073aea154f86538a9d765a.png'
import Prim3 from '../assest/home//primResidency/40eafa057428b0456ad131d655db6f9f7d17bfda.png'
import Prim4 from '../assest/home/primResidency/546a589f65473ddcb319beb12c082784a785afa9.png'
import Prim5 from '../assest/home/primResidency/2e6198eb0786bfb23a05292f945b11753e02e67b.png'
import Prim6 from '../assest/home/primResidency/820f5808b5785b3f72e6f29bfc63c194c3086a95.png'
import Mark1 from '../assest/home/marServices/d8399a6d02ee5bbbd97b2537295a0c29d415f25f.png'
import Mark2 from '../assest/home/marServices/54856b868c9cc667586c8cd9f410dc6b272b1501.png'
import Mark3 from '../assest/home/marServices/900008c0be0e4c0afd832793c6731b8d0b07f217.png'
import Mark4 from '../assest/home/marServices/d03b5eb592cfdecf5164d29901a7d9c783b0406b.png'
import Mark5 from '../assest/home/marServices/3b2af0d3c6e2f1e7c50f844c2d1e9e0baa1827c4.png'
import Mark6 from '../assest/home/marServices/061fa55d9a6942b1cb1f633ad8323b13012f3ffd.png'
import Mark7 from '../assest/home/marServices/d104a03822d6d7c033a7a09c17a14dd95d01987c.png'
import Mark8 from '../assest/home/marServices/f1b631b112a0f672ab706e77bcb79c9de76842ad.png'
import Acco1 from '../assest/home/accServices/0e2f7dc29be9a2aa98a219bf3c4c6f98b5ae3e16\ \(1\).png'
import Acco2 from '../assest/home/accServices/7706adffd4b2bf3c0c6c23a078c8da8384db5dc7\ \(1\).png'
import Acco3 from '../assest/home/accServices/2e36fe963e6c0a62bc9a76dc9f180a2a18caa7ad\ \(1\).png'
import Acco4 from '../assest/home/accServices/d693430b98f43290e0462f0b1621576146b9c9e7\ \(1\).png'
import Acco5 from '../assest/home/accServices/13c18c56a1a1fa8e5074ba233c7249f6d9c86927\ \(1\).png'
import Acco6 from '../assest/home/accServices/73cd7daf0f3ff198510957f1285a11d01443ca0c\ \(1\).png'
import Acco7 from '../assest/home/accServices/6efa3ceae8207beae6742eec8ff4b5aa85828672\ \(1\).png'
import Acco8 from '../assest/home/accServices/d644499ae323f99902aaac1ceea3b1eef99b5e6d\ \(1\).png'
import civileImage from '../assest/home/ourservic/018f70f4b830b29be56425b7f9c4e700b776bee0.png'
import app from '../assest/home/programming/تطبيقات-الجوال.png'
import web from '../assest/home/programming/webDisgner.webp'
import technicSupport from '../assest/home/programming/الدعم الفني.png'
import accountSys from '../assest/home/programming/accounting-system.jpg'
import hr from '../assest/home/programming/hr-product.jpg'
import managment from '../assest/home/programming/managment.webp'
import crm from '../assest/home/programming/crm.webp'
import trademarks from '../assest/home/Intellpropservices/trademarks.jpg'
const whatsappNumbers = {
    company: '+966509150333',
    support: '+966561103887',
    premium: "966509150333",
    marketing: '+966531906999',
    account: '+966564716444',
    programming: '+966554069111',
    Intellpropservices:'+966540062640'
};
const salam = 'السلام عليكم اريد استفسر عن';
// const HeaderImages = [
//     {
//         path: trImage,
//         whatsapp: `${salam} خدمة التدريب والتاهيل`,
//         page: ' خدمة التدريب والتاهيل',
//         number: whatsappNumbers.support
//     },
//     {
//         path: Insurance,
//         whatsapp: `${salam}التامين الصحي الشامل`,
//         page: ' التامين الصحي الشامل',
//         number: whatsappNumbers.support
//     },
//     {
//         path: SaberSservice,
//         whatsapp: `${salam} خدمة سابر`,
//         page: ' خدمة سابر',
//         number: whatsappNumbers.support
//     },
//     {
//         path: NajizService,
//         whatsapp: `${salam} خدمة ناجز`,
//         page: ' خدمة ناجز',
//         number: whatsappNumbers.support
//     },
//     {
//         path: MadadService,
//         whatsapp: `${salam} خدمة مدد`,
//         page: ' خدمة مدد',
//         number: whatsappNumbers.support
//     },
//     {
//         path: EngConsultation,
//         whatsapp: `${salam} خدمة الاستشارات الهندسية`,
//         page: ' خدمة الاستشارات الهندسية',
//         number: whatsappNumbers.support
//     },
//     {
//         path: ComCr1,
//         whatsapp: `${salam} الترخيص المهني`,
//         page: ' الترخيص المهني',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr2,
//         whatsapp: `${salam} الترخيص الزراعي`,
//         page: ' الترخيص الزراعي',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr3,
//         whatsapp: `${salam} ترخيص تجاري اجنبي`,
//         page: ' ترخيص تجاري اجنبي',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr4,
//         whatsapp: `${salam} ترخيص تجاري بشريك سعودي`,
//         page: ' ترخيص تجاري بشريك سعودي',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr5,
//         whatsapp: `${salam} ترخيص مهني بشريك سعودي`,
//         page: ' ترخيص مهني بشريك سعودي',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr6,
//         whatsapp: `${salam} ترخيص انشطة النقل`,
//         page: ' ترخيص انشطة النقل',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr7,
//         whatsapp: `${salam} الترخيص العقاري`,
//         page: ' الترخيص العقاري',
//         number: whatsappNumbers.company
//     },
//     {
//         path: ComCr8,
//         whatsapp: `${salam} ترخيص صناعي`,
//         page: ' ترخيص صناعي',
//         number: whatsappNumbers.company
//     },
//     {
//         path: Prim1,
//         whatsapp: `${salam} إقامة مستثمر أعمال`,
//         page: ' إقامة مستثمر أعمال',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Prim2,
//         whatsapp: `${salam} إقامة مميزة غير محددة المدة ومحددة المدة`,
//         page: ' إقامة مميزة غير محددة المدة ومحددة المدة',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Prim3,
//         whatsapp: `${salam} إقامة رائدة أعمال`,
//         page: 'الرئيسية > إقامة رائدة أعمال',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Prim4,
//         whatsapp: `${salam} إقامة مالك عقار`,
//         page: ' إقامة مالك عقار',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Prim5,
//         whatsapp: `${salam} إقامة الموهبة`,
//         page: ' إقامة الموهبة',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Prim6,
//         whatsapp: `${salam} إقامة الكفائة الاستثنائية`,
//         page: ' إقامة الكفائة الاستثنائية',
//         number: whatsappNumbers.premium
//     },
//     {
//         path: Mark1,
//         whatsapp: `${salam} إدراة وتنظيم الحفلات والمؤتمرات`,
//         page: ' إدراة وتنظيم الحفلات والمؤتمرات',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark2,
//         whatsapp: `${salam} تفعيل تابي وتمارا`,
//         page: ' تفعيل تابي وتمارا',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark3,
//         whatsapp: `${salam} تطوير صفحات الويب`,
//         page: ' تطوير صفحات الويب',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark4,
//         whatsapp: `${salam} رفع جوجل ماب`,
//         page: ' رفع جوجل ماب',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark5,
//         whatsapp: `${salam} رفع العلامات التجارية`,
//         page: ' رفع العلامات التجارية',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark6,
//         whatsapp: `${salam} إدارة وتنظيم المتاجر الالكترونية`,
//         page: " إدارة وتنظيم المتاجر الالكترونية",
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark7,
//         whatsapp: `${salam} إدارة حسابات السوشيال ميديا`,
//         page: " إدارة حسابات السوشيال ميديا",
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Mark8,
//         whatsapp: `${salam} تصوير المنتجات`,
//         page: ' تصوير المنتجات',
//         number: whatsappNumbers.marketing
//     },
//     {
//         path: Acco1,
//         whatsapp: `${salam} مسك الدفاتر المحاسبية`,
//         page: ' مسك الدفاتر المحاسبية',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco2,
//         whatsapp: `${salam} التهيئة والتدريب على الأنظمة المحاسبية`,
//         page: ' التهيئة والتدريب على الأنظمة المحاسبية',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco3,
//         whatsapp: `${salam} فحص اداء الأنظمة المحاسبية`,
//         page: ' فحص اداء الأنظمة المحاسبية',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco4,
//         whatsapp: `${salam} إدارة المخازن والجرد`,
//         page: ' إدارة المخازن والجرد',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco5,
//         whatsapp: `${salam} تقديم إستشارات محاسبية`,
//         page: " تقديم إستشارات محاسبية",
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco6,
//         whatsapp: `${salam} تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط`,
//         page: ' تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco7,
//         whatsapp: `${salam} إعداد القرارات الضريبية`,
//         page: 'إعداد القرارات الضريبية',
//         number: whatsappNumbers.account
//     },
//     {
//         path: Acco8,
//         whatsapp: `${salam} إعداد التقارير المالية والإدارية والختامية`,
//         page: ' إعداد التقارير المالية والإدارية والختامية',
//         number: whatsappNumbers.marketing
//     }, {
//         path: civileImage,
//         page: 'خدمات الدفاع المدني',
//         whatsapp: `${salam} السلام عليكم اريد استفسر عن خدمات الدفاع المدني`,
//         number: whatsappNumbers.support
//     },
//     {
//         path: app,
//         page: 'تطبيقات الموبايل',
//         whatsapp: `${salam} برمجة تطبيقات الموبايل`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: web,
//         page: 'المواقع الالكترونية',
//         whatsapp: `${salam} برمجة وتصميم المواقع الالكترونية`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: technicSupport,
//         page: 'الدعم الفني',
//         whatsapp: `${salam}  عن شيء بمجال خدماتكم`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: accountSys,
//         page: 'نظام المحاسبة',
//         whatsapp: `${salam} نظام المحاسبة`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: hr,
//         page: 'نطام الموارد البشرية',
//         whatsapp: `${salam} نظام HR`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: managment,
//         page: 'النظام الادراي',
//         whatsapp: `${salam} النظام الاداري`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: crm,
//         page: 'نظام CRM',
//         whatsapp: `${salam}  نظام ال CRM`,
//         number: whatsappNumbers.programming
//     },
//     {
//         path: trademarks,
//         page: 'العلامات التجارية',
//         whatsapp: `${salam}  علامة تجارية`,
//         number: whatsappNumbers.Intellpropservices
//     },
//     {
//         path: trademarks,
//         page: 'تسجيل براءة اختراع',
//         whatsapp: `${salam}   تسجيل براءة اختراع`,
//         number: whatsappNumbers.Intellpropservices
//     },
//     {
//         path: trademarks,
//         page: 'تسجيل منتج صناعي',
//         whatsapp: `${salam}   تسجيل منتج صناعي`,
//         number: whatsappNumbers.Intellpropservices
//     },
//     {
//         path: trademarks,
//         page: 'تسجيل حقوق نشر',
//         whatsapp: `${salam}   تسجيل حقوق نشر`,
//         number: whatsappNumbers.Intellpropservices
//     },
// ];
// export default HeaderImages;





const HeaderImages = [
    {
        path: trImage,
        whatsapp: `${salam} خدمة التدريب والتاهيل`,
        page: ' خدمة التدريب والتاهيل',
        number: whatsappNumbers.support,
        // بيانات Helmet / SEO المضافة:
        description: 'استفسر عن خدمة التدريب والتاهيل والمساعدة في الاجراءات.',
        keywords: 'تدريب، تأهيل، خدمات أعمال، دعم',
        canonicalUrl: null // يرجى استبدالها بالرابط الصحيح
    },
    {
        path: Insurance,
        whatsapp: `${salam}التامين الصحي الشامل`,
        page: ' التامين الصحي الشامل',
        number: whatsappNumbers.support,
        description: 'كل ما تحتاج معرفته عن التامين الصحي الشامل والمساعدة في التسجيل.',
        keywords: 'تأمين صحي، تأمين شامل، خدمات صحية',
        canonicalUrl: null
    },
    {
        path: SaberSservice,
        whatsapp: `${salam} خدمة سابر`,
        page: ' خدمة سابر',
        number: whatsappNumbers.support,
        description: 'تسهيل معاملاتك مع خدمة سابر ومتطلبات الجودة والمطابقة.',
        keywords: 'سابر، مطابقة، جودة، شهادات',
        canonicalUrl: null
    },
    {
        path: NajizService,
        whatsapp: `${salam} خدمة ناجز`,
        page: ' خدمة ناجز',
        number: whatsappNumbers.support,
        description: 'إجراءات وخدمات ناجز القانونية والقضائية بسهولة وفعالية.',
        keywords: 'ناجز، محاكم، خدمات قانونية، قضاء',
        canonicalUrl: null
    },
    {
        path: MadadService,
        whatsapp: `${salam} خدمة مدد`,
        page: ' خدمة مدد',
        number: whatsappNumbers.support,
        description: 'استفسر عن خدمة مدد لتيسير إدارة الرواتب وعقود العمل.',
        keywords: 'مدد، رواتب، عقود عمل، موارد بشرية',
        canonicalUrl: null
    },
    {
        path: EngConsultation,
        whatsapp: `${salam} خدمة الاستشارات الهندسية`,
        page: ' خدمة الاستشارات الهندسية',
        number: whatsappNumbers.support,
        description: 'استشارات هندسية متخصصة في كافة المجالات الهندسية.',
        keywords: 'استشارات هندسية، هندسة، مشاريع، تصميم',
        canonicalUrl: null
    },
    {
        path: ComCr1,
        whatsapp: `${salam} الترخيص المهني`,
        page: ' الترخيص المهني',
        number: whatsappNumbers.company,
        description: 'متطلبات وإجراءات الحصول على الترخيص المهني الجديد.',
        keywords: 'ترخيص مهني، سجل تجاري، وزارة التجارة',
        canonicalUrl: null
    },
    {
        path: ComCr2,
        whatsapp: `${salam} الترخيص الزراعي`,
        page: ' الترخيص الزراعي',
        number: whatsappNumbers.company,
        description: 'إجراءات الترخيص الزراعي لجميع الأنشطة الزراعية والاستثمارية.',
        keywords: 'ترخيص زراعي، استثمار زراعي، خدمات زراعية',
        canonicalUrl: null
    },
    {
        path: ComCr3,
        whatsapp: `${salam} ترخيص تجاري اجنبي`,
        page: ' ترخيص تجاري اجنبي',
        number: whatsappNumbers.company,
        description: 'الحصول على ترخيص تجاري للأجانب وإجراءات الاستثمار الأجنبي.',
        keywords: 'ترخيص تجاري أجنبي، استثمار أجنبي، سجل تجاري',
        canonicalUrl: null
    },
    {
        path: ComCr4,
        whatsapp: `${salam} ترخيص تجاري بشريك سعودي`,
        page: ' ترخيص تجاري بشريك سعودي',
        number: whatsappNumbers.company,
        description: 'إجراءات تأسيس ترخيص تجاري بشريك سعودي ومزايا الشراكة.',
        keywords: 'ترخيص تجاري، شريك سعودي، سجل تجاري، شراكة',
        canonicalUrl: null
    },
    {
        path: ComCr5,
        whatsapp: `${salam} ترخيص مهني بشريك سعودي`,
        page: ' ترخيص مهني بشريك سعودي',
        number: whatsappNumbers.company,
        description: 'خطوات استخراج ترخيص مهني بالشراكة مع مستثمر سعودي.',
        keywords: 'ترخيص مهني، شريك سعودي، سجل مهني',
        canonicalUrl: null
    },
    {
        path: ComCr6,
        whatsapp: `${salam} ترخيص انشطة النقل`,
        page: ' ترخيص انشطة النقل',
        number: whatsappNumbers.company,
        description: 'تراخيص جميع أنشطة النقل البري والبحري والجوي.',
        keywords: 'ترخيص نقل، أنشطة نقل، لوجستيات',
        canonicalUrl: null
    },
    {
        path: ComCr7,
        whatsapp: `${salam} الترخيص العقاري`,
        page: ' الترخيص العقاري',
        number: whatsappNumbers.company,
        description: 'الحصول على الترخيص العقاري والمزاولة المهنية في القطاع العقاري.',
        keywords: 'ترخيص عقاري، عقارات، وساطة عقارية',
        canonicalUrl: null
    },
    {
        path: ComCr8,
        whatsapp: `${salam} ترخيص صناعي`,
        page: ' ترخيص صناعي',
        number: whatsappNumbers.company,
        description: 'جميع خدمات استخراج وتجديد التراخيص الصناعية.',
        keywords: 'ترخيص صناعي، مصانع، صناعة، استثمار صناعي',
        canonicalUrl: null
    },
    {
        path: Prim1,
        whatsapp: `${salam} إقامة مستثمر أعمال`,
        page: ' إقامة مستثمر أعمال',
        number: whatsappNumbers.premium,
        description: 'برنامج إقامة مستثمر أعمال ومزاياها للمستثمرين.',
        keywords: 'إقامة مستثمر، إقامة مميزة، استثمار',
        canonicalUrl: null
    },
    {
        path: Prim2,
        whatsapp: `${salam} إقامة مميزة غير محددة المدة ومحددة المدة`,
        page: ' إقامة مميزة غير محددة المدة ومحددة المدة',
        number: whatsappNumbers.premium,
        description: 'شروط ومزايا الإقامة المميزة بنوعيها: محددة وغير محددة المدة.',
        keywords: 'إقامة مميزة، غير محددة المدة، محددة المدة، إقامة',
        canonicalUrl: null
    },
    {
        path: Prim3,
        whatsapp: `${salam} إقامة رائدة أعمال`,
        page: 'الرئيسية > إقامة رائدة أعمال',
        number: whatsappNumbers.premium,
        description: 'الحصول على إقامة رائدة أعمال ودعم المشاريع المبتكرة.',
        keywords: 'إقامة رائدة أعمال، ريادة، ابتكار، إقامة مميزة',
        canonicalUrl: null
    },
    {
        path: Prim4,
        whatsapp: `${salam} إقامة مالك عقار`,
        page: ' إقامة مالك عقار',
        number: whatsappNumbers.premium,
        description: 'تفاصيل إقامة مالك عقار لغير السعوديين وشروطها.',
        keywords: 'إقامة مالك عقار، استثمار عقاري، إقامة مميزة',
        canonicalUrl: null
    },
    {
        path: Prim5,
        whatsapp: `${salam} إقامة الموهبة`,
        page: ' إقامة الموهبة',
        number: whatsappNumbers.premium,
        description: 'شروط برنامج إقامة الموهبة لجذب الكفاءات والمواهب.',
        keywords: 'إقامة الموهبة، كفاءات، إقامة مميزة',
        canonicalUrl: null
    },
    {
        path: Prim6,
        whatsapp: `${salam} إقامة الكفائة الاستثنائية`,
        page: ' إقامة الكفائة الاستثنائية',
        number: whatsappNumbers.premium,
        description: 'برنامج إقامة الكفاءة الاستثنائية للخبراء والمحترفين.',
        keywords: 'إقامة كفاءة استثنائية، خبراء، إقامة مميزة',
        canonicalUrl: null
    },
    {
        path: Mark1,
        whatsapp: `${salam} إدراة وتنظيم الحفلات والمؤتمرات`,
        page: ' إدراة وتنظيم الحفلات والمؤتمرات',
        number: whatsappNumbers.marketing,
        description: 'خدمات متكاملة لإدارة وتنظيم الحفلات والمؤتمرات والفعاليات.',
        keywords: 'تنظيم فعاليات، مؤتمرات، حفلات، إدارة مناسبات',
        canonicalUrl: null
    },
    {
        path: Mark2,
        whatsapp: `${salam} تفعيل تابي وتمارا`,
        page: ' تفعيل تابي وتمارا',
        number: whatsappNumbers.marketing,
        description: 'مساعدتك في تفعيل خدمات الدفع الآجل (تابي وتمارا) في متجرك.',
        keywords: 'تابي، تمارا، دفع آجل، متاجر الكترونية',
        canonicalUrl: null
    },
    {
        path: Mark3,
        whatsapp: `${salam} تطوير صفحات الويب`,
        page: ' تطوير صفحات الويب',
        number: whatsappNumbers.marketing,
        description: 'تصميم وتطوير صفحات الويب الاحترافية المتوافقة مع محركات البحث.',
        keywords: 'تطوير ويب، تصميم مواقع، صفحات هبوط، SEO',
        canonicalUrl: null
    },
    {
        path: Mark4,
        whatsapp: `${salam} رفع جوجل ماب`,
        page: ' رفع جوجل ماب',
        number: whatsappNumbers.marketing,
        description: 'خدمة رفع وتثبيت موقع منشأتك على خرائط جوجل (Google Maps).',
        keywords: 'رفع جوجل ماب، خرائط جوجل، SEO محلي',
        canonicalUrl: null
    },
    {
        path: Mark5,
        whatsapp: `${salam} رفع العلامات التجارية`,
        page: ' رفع العلامات التجارية',
        number: whatsappNumbers.marketing,
        description: 'خدمات تسجيل وحماية العلامات التجارية والملكية الفكرية.',
        keywords: 'علامات تجارية، تسجيل علامة، ملكية فكرية',
        canonicalUrl: null
    },
    {
        path: Mark6,
        whatsapp: `${salam} إدارة وتنظيم المتاجر الالكترونية`,
        page: " إدارة وتنظيم المتاجر الالكترونية",
        number: whatsappNumbers.marketing,
        description: 'إدارة شاملة لمتجرك الإلكتروني وتطوير أداء المبيعات.',
        keywords: 'إدارة متاجر، متجر الكتروني، تسويق رقمي',
        canonicalUrl: null
    },
    {
        path: Mark7,
        whatsapp: `${salam} إدارة حسابات السوشيال ميديا`,
        page: " إدارة حسابات السوشيال ميديا",
        number: whatsappNumbers.marketing,
        description: 'خدمة احترافية لإدارة حساباتك على وسائل التواصل الاجتماعي.',
        keywords: 'إدارة سوشيال ميديا، تسويق، محتوى، تواصل اجتماعي',
        canonicalUrl: null
    },
    {
        path: Mark8,
        whatsapp: `${salam} تصوير المنتجات`,
        page: ' تصوير المنتجات',
        number: whatsappNumbers.marketing,
        description: 'خدمات تصوير المنتجات الاحترافي للمتاجر والمواقع الإلكترونية.',
        keywords: 'تصوير منتجات، إعلانات، جودة عالية',
        canonicalUrl: null
    },
    {
        path: Acco1,
        whatsapp: `${salam} مسك الدفاتر المحاسبية`,
        page: ' مسك الدفاتر المحاسبية',
        number: whatsappNumbers.account,
        description: 'خدمات مسك الدفاتر والسجلات المحاسبية بدقة واحترافية.',
        keywords: 'مسك دفاتر، محاسبة، سجلات مالية',
        canonicalUrl: null
    },
    {
        path: Acco2,
        whatsapp: `${salam} التهيئة والتدريب على الأنظمة المحاسبية`,
        page: ' التهيئة والتدريب على الأنظمة المحاسبية',
        number: whatsappNumbers.account,
        description: 'تدريب الموظفين على استخدام الأنظمة المحاسبية بكفاءة.',
        keywords: 'تدريب محاسبي، أنظمة محاسبية، تهيئة',
        canonicalUrl: null
    },
    {
        path: Acco3,
        whatsapp: `${salam} فحص اداء الأنظمة المحاسبية`,
        page: ' فحص اداء الأنظمة المحاسبية',
        number: whatsappNumbers.account,
        description: 'تقييم وفحص أداء الأنظمة المحاسبية وتحديد نقاط التحسين.',
        keywords: 'فحص محاسبي، تقييم أنظمة، مراجعة',
        canonicalUrl: null
    },
    {
        path: Acco4,
        whatsapp: `${salam} إدارة المخازن والجرد`,
        page: ' إدارة المخازن والجرد',
        number: whatsappNumbers.account,
        description: 'تنظيم وإدارة المخازن والجرد الدوري والمستمر للمنشآت.',
        keywords: 'إدارة مخازن، جرد، محاسبة تكاليف',
        canonicalUrl: null
    },
    {
        path: Acco5,
        whatsapp: `${salam} تقديم إستشارات محاسبية`,
        page: " تقديم إستشارات محاسبية",
        number: whatsappNumbers.account,
        description: 'استشارات محاسبية ومالية لتطوير الأداء المالي للمنشأة.',
        keywords: 'استشارات محاسبية، مالية، تطوير أعمال',
        canonicalUrl: null
    },
    {
        path: Acco6,
        whatsapp: `${salam} تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط`,
        page: ' تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط',
        number: whatsappNumbers.account,
        description: 'توفير وتركيب أنظمة محاسبية مخصصة لاحتياجات عملك.',
        keywords: 'أنظمة محاسبية، برامج مالية، حلول برمجية',
        canonicalUrl: null
    },
    {
        path: Acco7,
        whatsapp: `${salam} إعداد القرارات الضريبية`,
        page: 'إعداد القرارات الضريبية',
        number: whatsappNumbers.account,
        description: 'إعداد وتقديم الإقرارات الضريبية (القيمة المضافة، الدخل) بدقة.',
        keywords: 'إقرارات ضريبية، ضريبة القيمة المضافة، زكاة',
        canonicalUrl: null
    },
    {
        path: Acco8,
        whatsapp: `${salam} إعداد التقارير المالية والإدارية والختامية`,
        page: ' إعداد التقارير المالية والإدارية والختامية',
        number: whatsappNumbers.marketing,
        description: 'تحضير تقارير مالية وإدارية وختامية مفصلة لدعم اتخاذ القرار.',
        keywords: 'تقارير مالية، تقارير إدارية، ميزانية، تحليل مالي',
        canonicalUrl: null
    },
    {
        path: civileImage,
        page: 'خدمات الدفاع المدني',
        whatsapp: `${salam} السلام عليكم اريد استفسر عن خدمات الدفاع المدني`,
        number: whatsappNumbers.support,
        description: 'استفسر عن متطلبات واجراءات خدمات الدفاع المدني وتراخيص السلامة.',
        keywords: 'دفاع مدني، تراخيص سلامة، وقاية، حماية',
        canonicalUrl: null
    },
    {
        path: app,
        page: 'تطبيقات الموبايل',
        whatsapp: `${salam} برمجة تطبيقات الموبايل`,
        number: whatsappNumbers.programming,
        description: 'خدمات برمجة وتطوير تطبيقات الموبايل (iOS و Android) باحترافية.',
        keywords: 'تطبيقات موبايل، برمجة تطبيقات، iOS، Android',
        canonicalUrl: null
    },
    {
        path: web,
        page: 'المواقع الالكترونية',
        whatsapp: `${salam} برمجة وتصميم المواقع الالكترونية`,
        number: whatsappNumbers.programming,
        description: 'تصميم وبرمجة مواقع إلكترونية عصرية ومتجاوبة لجميع الأغراض.',
        keywords: 'تصميم مواقع، برمجة مواقع، تطوير ويب، استضافة',
        canonicalUrl: null
    },
    {
        path: technicSupport,
        page: 'الدعم الفني',
        whatsapp: `${salam}  عن شيء بمجال خدماتكم`,
        number: whatsappNumbers.programming,
        description: 'خدمة الدعم الفني المستمرة لجميع أنظمتك وحلولك التقنية.',
        keywords: 'دعم فني، تقنية معلومات، صيانة، حلول تقنية',
        canonicalUrl: null
    },
    {
        path: accountSys,
        page: 'نظام المحاسبة',
        whatsapp: `${salam} نظام المحاسبة`,
        number: whatsappNumbers.programming,
        description: 'توفير وتركيب أنظمة محاسبية متكاملة لإدارة حسابات شركتك.',
        keywords: 'نظام محاسبة، برنامج مالي، ERP',
        canonicalUrl: null
    },
    {
        path: hr,
        page: 'نطام الموارد البشرية',
        whatsapp: `${salam} نظام HR`,
        number: whatsappNumbers.programming,
        description: 'حلول نظام الموارد البشرية (HR) لإدارة الموظفين والرواتب.',
        keywords: 'نظام موارد بشرية، HR، شؤون موظفين',
        canonicalUrl: null
    },
    {
        path: managment,
        page: 'النظام الادراي',
        whatsapp: `${salam} النظام الاداري`,
        number: whatsappNumbers.programming,
        description: 'توفير أنظمة إدارية متطورة لتنظيم العمليات الداخلية والتحكم بها.',
        keywords: 'نظام إداري، ERP، إدارة عمليات',
        canonicalUrl: null
    },
    {
        path: crm,
        page: 'نظام CRM',
        whatsapp: `${salam}  نظام ال CRM`,
        number: whatsappNumbers.programming,
        description: 'تطبيق وإدارة نظام إدارة علاقات العملاء (CRM) لزيادة المبيعات.',
        keywords: 'نظام CRM، علاقات عملاء، مبيعات، تسويق',
        canonicalUrl: null
    },
    {
        path: trademarks,
        page: 'العلامات التجارية',
        whatsapp: `${salam}  علامة تجارية`,
        number: whatsappNumbers.Intellpropservices,
        description: 'تسجيل وحماية علامتك التجارية محلياً ودولياً.',
        keywords: 'تسجيل علامة تجارية، ملكية فكرية',
        canonicalUrl: null
    },
    {
        path: trademarks,
        page: 'تسجيل براءة اختراع',
        whatsapp: `${salam}   تسجيل براءة اختراع`,
        number: whatsappNumbers.Intellpropservices,
        description: 'إجراءات تسجيل براءة الاختراع لحماية اختراعاتك التقنية والصناعية.',
        keywords: 'براءة اختراع، حماية اختراع، ملكية فكرية',
        canonicalUrl: null
    },
    {
        path: trademarks,
        page: 'تسجيل منتج صناعي',
        whatsapp: `${salam}   تسجيل منتج صناعي`,
        number: whatsappNumbers.Intellpropservices,
        description: 'تسجيل منتج صناعي جديد وحماية تصميمه وشكله.',
        keywords: 'منتج صناعي، تسجيل تصميم، ملكية فكرية',
        canonicalUrl: null
    },
    {
        path: trademarks,
        page: 'تسجيل حقوق نشر',
        whatsapp: `${salam}   تسجيل حقوق نشر`,
        number: whatsappNumbers.Intellpropservices,
        description: 'تسجيل وحماية حقوق النشر والطبع للمصنفات الأدبية والفنية.',
        keywords: 'حقوق نشر، ملكية فكرية، مصنفات',
        canonicalUrl: null
    },
];

export default HeaderImages;